module.exports = __webpack_public_path__ + "img/std.3475dee3.png";